import React from 'react';
import Select from 'react-select';
import './Style.css';

const MultiSelect = ({ errorServices, handleChange, selectedService, options, placeholder, disabled, className = "w-90" }) => {
  return <Select styles={{ menu: provided => ({ ...provided, zIndex: 9999 }) }} className={className} clearValue closeMenuOnSelect={false} isMulti value={selectedService} onChange={handleChange} options={options} isDisabled={disabled} placeholder={placeholder ? placeholder : 'Please select...'} />;
};

export default MultiSelect;
